module.exports = __webpack_public_path__ + "img/edited.3b9f4cf8.svg";